import { forwardRef, type InputHTMLAttributes } from 'react';
import { cx } from '@/lib/cx';

export type InputProps = InputHTMLAttributes<HTMLInputElement>;

/** Prototype .input (CSS line 32). */
export const Input = forwardRef<HTMLInputElement, InputProps>(function Input({ className, ...rest }, ref) {
  return <input ref={ref} className={cx('input', className)} {...rest} />;
});
